
import React from 'react';
import { HormoneChartDisplay } from './hormone-chart/HormoneChartDisplay';
import { CycleData, HormoneType } from '@/utils/cycle-tracking';

interface HormoneChartProps {
  cycleData: CycleData | null;
  selectedHormones: HormoneType[];
  showPhases?: boolean;
}

export const HormoneChart: React.FC<HormoneChartProps> = ({ 
  cycleData, 
  selectedHormones,
  showPhases = true
}) => {
  if (!cycleData) {
    return (
      <div className="flex justify-center items-center h-60 bg-gray-50 rounded-lg border">
        <p className="text-gray-500">No cycle data available</p>
      </div>
    );
  }
  
  return (
    <HormoneChartDisplay 
      cycleData={cycleData} 
      selectedHormones={selectedHormones} 
      showPhases={showPhases} 
    />
  );
};
